<div class="c-modal">
	<div mat-dialog-content class="c-modal__dialog" style="max-width:950px;">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<p class="c-text">{{ 'Modal.Content.CSV_Import_Info' | translate}}</p>
			<div class="u-ost-md u-osb-xl" *ngIf="vm.canUserManuallyAddInsurance">
				<div class="c-content c-content--border-bottom u-no-ph u-hidden@up-to-md">
					<div class="o-grid" style="font-size:13px;">
						<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
							<p class="c-text c-text--gray" aria-hidden="true">firstname</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
							<p class="c-text c-text--gray" aria-hidden="true">lastname</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
							<p class="c-text c-text--gray" aria-hidden="true">email</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">personal_code</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">policy_number</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">valid_from</p>
						</div>
						<!-- div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">valid_to</p>
						</div-->
						<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">additional_info</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">additional_info_2</p>
						</div>
					</div>
				</div>
				<ul class="c-list">
					<li *ngFor="let row of vm.rows">
						<div class="c-content c-content--border-bottom u-no-ph">
							<div class="o-grid o-grid--wrap" style="font-size:13px;">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">firstname</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right@up-to-md">{{row.firstname}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">lastname</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right@up-to-md">{{row.lastname}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">email</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right@up-to-md">{{row.email}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">personal_code</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.personal_code}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">policy_number</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.policy_number}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">valid_from</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.valid_from}}</p>
										</div>
									</div>
								</div>
								<!-- div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">valid_to</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.valid_to}}</p>
										</div>
									</div>
								</div-->
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">additional_info</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.additional_info}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">additional_info_2</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.additional_info_2}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="u-ost-md u-osb-xl" *ngIf="!vm.canUserManuallyAddInsurance">
				<div class="c-content c-content--border-bottom u-no-ph u-hidden@up-to-md">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
							<p class="c-text c-text--gray" aria-hidden="true">firstname</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
							<p class="c-text c-text--gray" aria-hidden="true">lastname</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
							<p class="c-text c-text--gray" aria-hidden="true">email</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">personal_code</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">additional_info</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
							<p class="c-text c-text--gray c-text--right" aria-hidden="true">additional_info_2</p>
						</div>
					</div>
				</div>
				<ul class="c-list">
					<li *ngFor="let row of vm.rows">
						<div class="c-content c-content--border-bottom u-no-ph">
							<div class="o-grid o-grid--wrap">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">firstname</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right@up-to-md">{{row.firstname}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">lastname</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right@up-to-md">{{row.lastname}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">email</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right@up-to-md">{{row.email}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">personal_code</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.personal_code}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">additional_info</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.additional_info}}</p>
										</div>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl u-hidden@md-and-up">
											<p class="c-text c-text--gray" aria-hidden="true">additional_info_2</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100@md-and-up o-grid__cell--slim u-no-pr">
											<p class="c-text c-text--right">{{row.additional_info_2}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<p class="c-text">{{ 'Modal.Content.CSV_Import_Info_Add' | translate }}</p>
		</div>
		<div class="c-modal__footer">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p" *ngIf="vm.canUserManuallyAddInsurance">
					<a href="templates/employees_template_with_insurance.csv" target="_self" download="employees_template_with_insurance.csv" class="c-button c-button--s1 c-button--fit">{{ 'Modal.Button.CSV_Template_Download' | translate}}</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p" *ngIf="!vm.canUserManuallyAddInsurance">
					<a href="templates/employees_template.csv" target="_self" download="employees_template.csv" class="c-button c-button--s1 c-button--fit">{{ 'Modal.Button.CSV_Template_Download' | translate}}</a>
				</div>
			</div>
		</div>
	</div>
</div>
